"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseui = require("baseui");

var _button = require("baseui/button");

var _link = require("baseui/link");

var _typography = require("baseui/typography");

var _propTypes = require("prop-types");

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _typography2 = require("../typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Blockquote = (0, _baseui.styled)('blockquote', function (_ref) {
  var $theme = _ref.$theme;
  return {
    borderLeft: "0.2em solid ".concat($theme.colors.mono700),
    paddingLeft: '1em'
  };
});
var StyledListItem = (0, _baseui.styled)('li', function (_ref2) {
  var $theme = _ref2.$theme;
  var breakpoints = $theme.breakpoints,
      colors = $theme.colors,
      typography = $theme.typography;
  return _objectSpread({}, typography.font300, _defineProperty({
    color: colors.mono200
  }, "@media screen and (min-width: ".concat(breakpoints.medium, "px)"), _objectSpread({}, typography.font400)));
});
var StyledAnchor = (0, _baseui.withStyle)(_link.StyledLink, function (_ref3) {
  var $theme = _ref3.$theme;
  return {
    color: $theme.colors.mono600
  };
}); // eslint-disable-next-line react/prop-types

var ButtonMore = function ButtonMore(_ref4) {
  var children = _ref4.children,
      onClick = _ref4.onClick,
      rest = _objectWithoutProperties(_ref4, ["children", "onClick"]);

  return _react["default"].createElement(_button.Button, _extends({
    kind: _button.KIND.minimal,
    $style: function $style(_ref5) {
      var $theme = _ref5.$theme;
      return {
        color: $theme.colors.mono600,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        ':hover': {
          backgroundColor: 'transparent',
          color: $theme.colors.mono600
        },
        ':focus': {
          backgroundColor: 'transparent',
          color: $theme.colors.mono600
        },
        ':active': {
          backgroundColor: 'transparent',
          color: $theme.colors.mono600
        }
      };
    },
    onClick: onClick
  }, rest), children);
};

var Root = (0, _baseui.styled)('div', function (_ref6) {
  var $theme = _ref6.$theme,
      $last = _ref6.$last;
  var colors = $theme.colors,
      sizing = $theme.sizing;
  return {
    borderBottom: $last ? 'none' : "1px solid ".concat(colors.mono900),
    marginBottom: $last ? sizing.scale100 : sizing.scale800,
    paddingTop: sizing.scale200,
    paddingBottom: sizing.scale600,
    paddingLeft: 0,
    paddingRight: 0
  };
});

var withFilterByIndex = function withFilterByIndex(WrappedListItem) {
  return function (_ref7) {
    var index = _ref7.index,
        parentChildCount = _ref7.parentChildCount,
        rest = _objectWithoutProperties(_ref7, ["index", "parentChildCount"]);

    if (index > 0) {
      return null;
    }

    return _react["default"].createElement(WrappedListItem, rest);
  };
};

var withStyledListItem = function withStyledListItem(WrappedListItem) {
  return function (_ref8) {
    var parentChildCount = _ref8.parentChildCount,
        ordered = _ref8.ordered,
        tight = _ref8.tight,
        rest = _objectWithoutProperties(_ref8, ["parentChildCount", "ordered", "tight"]);

    return _react["default"].createElement(WrappedListItem, rest);
  };
};

var ReviewItem = function ReviewItem(_ref9) {
  var author = _ref9.author,
      content = _ref9.content,
      last = _ref9.last,
      onClick = _ref9.onClick,
      rest = _objectWithoutProperties(_ref9, ["author", "content", "last", "onClick"]);

  return _react["default"].createElement(Root, _extends({}, rest, {
    $last: last
  }), _react["default"].createElement(_typography.Label3, {
    color: "mono600"
  }, author), _react["default"].createElement(_reactMarkdown["default"], {
    includeNodeIndex: true,
    source: content,
    renderers: {
      blockquote: withFilterByIndex(Blockquote),
      link: withFilterByIndex(StyledAnchor),
      listItem: withStyledListItem(StyledListItem),
      paragraph: withFilterByIndex(_typography2.P1)
    }
  }), _react["default"].createElement(ButtonMore, {
    onClick: onClick
  }, "Read more"));
};

exports.ReviewItem = ReviewItem;
ReviewItem.propTypes = {
  author: _propTypes.node.isRequired,
  content: _propTypes.string.isRequired,
  last: _propTypes.bool,
  onClick: _propTypes.func.isRequired
};
ReviewItem.defaultProps = {
  last: false
};